<template>
  <div class="popup__layer active">
    <div class="popup__edit">
      <div class="popup__edit--title">
        {{ $t(`account.edit.changeAccountData`) }}
      </div>
      <div class="popup__close" @click="close">
        <span class="glicon-close-large"></span>
      </div>

      <form>
        <div class="form__group">
          <gl-input
            id="company.displayName"
            v-model.trim="companyData.displayName"
            v-skeletor:onChange="setValue"
            :type="'text'"
            :label="$t(`account.edit.companyName`)"
            :placeholder="$t(`account.edit.companyName`)"
            :value="companyData.displayName"
            :errormessage="
              !$v.companyData.displayName.hasWhiteSpaces ? $t('errors.invalidName') : null
            "
          >
          </gl-input>
        </div>
        <div class="form__group">
          <gl-input
            id="company.cid"
            v-model.trim="$v.companyData.cid.$model"
            v-skeletor:onChange="setValue"
            :type="'text'"
            :label="$t('nouns.CID')"
            :placeholder="$t('nouns.CID')"
            :value="companyData.cid"
            :errormessage="!$v.companyData.cid.hasWhiteSpaces ? $t('errors.invalidCIF') : null"
          >
          </gl-input>
        </div>
      </form>
      <div class="popup__buttons">
        <gl-button
          id="company.btn-cancel"
          color-secondary
          :type="'button'"
          :text="$t('actions.cancel')"
          @onClick.prevent="close"
        ></gl-button>
        <gl-button
          id="company.btn-update"
          color-primary
          :type="'button'"
          :text="$t('actions.update')"
          :disabled="$v.$invalid || !dirtyFields"
          @onClick.prevent="updateData"
        ></gl-button>
      </div>
    </div>
  </div>
</template>

<script>
import { formatIds } from '../../../utils/functions.js';

export default {
  name: 'PopUpCompany',
  props: {
    clientData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      companyData: {
        displayName: null,
        cid: null
      },
      errorMessages: {},
      dirtyFields: false
    };
  },
  created() {
    let { displayName, cid, name } = this.clientData;
    this.companyData.displayName = displayName || name;
    this.companyData.cid = cid;
  },
  methods: {
    setValue(field, value, dirty) {
      this.setForm(formatIds(field), value, dirty);
      this.setDirtyField(dirty);
    },
    setForm(attr, value) {
      this.companyData[attr] = value;
    },
    setDirtyField(dirty) {
      this.dirtyFields = dirty;
    },
    close() {
      this.$emit('close', false);
    },
    async updateData() {
      let updateData = {
        body: this.companyData,
        notification: {
          type: 'success',
          message: `feedback.success.changeAccountData`,
          fieldToEdit: 'changeAccountData',
          show: true
        }
      };
      this.$emit('update-client', updateData);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.close();
    }
  },
  validations: {
    companyData: {
      cid: {
        hasWhiteSpaces(value) {
          const isNotWhiteSpaces = new RegExp(/^\S*$/);
          return isNotWhiteSpaces.test(value);
        }
      },
      displayName: {
        hasWhiteSpaces(value) {
          return value && value.trim() ? true : false;
        }
      }
    }
  }
};
</script>
